import {useGetStacCollection} from '@src/api/catalog.ts';
import {useGetCollectionLayers} from '@src/api/configurations.ts';
import useVisualizationParams from '@src/hooks/useVisualizationParams.ts';
import {Layer} from '@src/types/configurations';

export const useSuperResLayer = (): {layer: Layer | null} => {
  const {configurationId, collectionId} = useVisualizationParams();
  const {layers} = useGetCollectionLayers(configurationId, collectionId);
  const {data: collection} = useGetStacCollection(collectionId);

  const trueColorLayer =
    layers?.find(layer => {
      const evalScript = layer.styles[0]?.evalScript ?? '';
      return (
        evalScript.match(/(true colou?r)/i) &&
        evalScript.includes('"red"') &&
        evalScript.includes('"green"') &&
        evalScript.includes('"blue"')
      );
    }) ?? null;

  const isPlanetScope = collection?.summaries['eo:bands']?.some(band => {
    return band.name === 'nir';
  });

  const layer = isPlanetScope ? trueColorLayer : null;

  return {layer};
};
